import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/ar-images/hezx.png'


const _hoisted_1 = { class: "vr-simulation" }
const _hoisted_2 = { class: "yxhd" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "content-title" }
const _hoisted_6 = { class: "wmdys" }
const _hoisted_7 = { class: "wmdys-content" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "wmdys-content-list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "list-box" }
const _hoisted_13 = { class: "counselling-btn" }

import { ref } from 'vue'
import { modelTypes } from '@/config';
import SubTitle from '@/components/SubTitle.vue';
import ExampleIntroduction from '@/components/common/ExampleIntroduction.vue';
import StepProcess from '@/components/common/StepProcess.vue';
import { exampleDatas } from '@/config/index'
import store from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'VRSimulation',
  setup(__props) {

const wmdysDataList = [
  {
    title: '技术优势',
    list: ['· 全面的数据获取能力', '· 高效率高精度', '· 强大的适应性与稳定性', '· 高沉浸式与互动性'],
    url: require('@/assets/images/ar-images/wmdys-vr2.png')
  },
  {
    title: '硬件优势',
    list: ['· 与XR领域头部硬件商达成长期战略合作', '· 根据不同的场景需求，匹配最佳硬件方案'],
    url: require('@/assets/images/ar-images/wmdys-vr3.png')
  },
  {
    title: '自研软件',
    list: ['· 运用自研的元宇宙虚实融合应用平台-混空Studio，低成本、高效率快速创作搭建虚实融合场景。'],
    url: require('@/assets/images/ar-images/wmdys-vr1.png')
  }
]
const wmdysActiveIndex = ref(0)

const handleEvent = (type: number) => {
  let contactUsTop: any = store.state.contactUsTop;
  if (type == 1) {
    contactUsTop = {
      bottom: 457 + 'rem'
    }
  } else {
    contactUsTop = {
      top: 1625 + 'rem'
    }
  }
  store.state.contactUsTop = JSON.parse(JSON.stringify(contactUsTop))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SubTitle, { "title-text": "应用场景" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modelTypes)['virtual-vr'], (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.header
          }, [
            _createElementVNode("img", {
              src: item.image,
              alt: ""
            }, null, 8, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.remarkList, (e, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(e), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.header), 1)
          ]))
        }), 128)),
        _createElementVNode("div", {
          class: "item hzzx",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleEvent(2)))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: ""
          }, null, -1)
        ]))])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(SubTitle, {
        "mode-class": "black-style",
        "title-text": "我们的优势"
      }),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", {
          src: wmdysDataList[wmdysActiveIndex.value].url
        }, null, 8, _hoisted_8),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(wmdysDataList, (item, index) => {
            return _createElementVNode("div", {
              key: index,
              class: _normalizeClass(wmdysActiveIndex.value == index ? 'active' : ''),
              onClick: ($event: any) => (wmdysActiveIndex.value = index)
            }, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (e, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(e), 1))
                }), 128))
              ])
            ], 10, _hoisted_10)
          }), 64))
        ])
      ])
    ]),
    _createVNode(ExampleIntroduction, {
      exampleData: _unref(exampleDatas).xnfz
    }, null, 8, ["exampleData"]),
    _createVNode(StepProcess, {
      "step-title": ['沉浸式体验', '一站式部署流程'],
      "step-type": "step1"
    }),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleEvent(1)))
      }, "合作咨询")
    ])
  ]))
}
}

})